// removed by extract-text-webpack-plugin
module.exports = {"page":"page__2OBzh"};


//////////////////
// WEBPACK FOOTER
// ./routes/ebike-finder/style.css
// module id = ZZAQ
// module chunks = 3